
<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>Clarification</h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-lg std-scholarship">
    <div class="container-fluid">
        <app-clarification-inner></app-clarification-inner>
    </div>
</section>
